module.exports = __webpack_public_path__ + "img/tonearm-black.9c903d4b.png";